/* eslint-disable camelcase */
// eslint-disable-next-line no-use-before-define
import React from "react";
import { useNavigate } from "react-router-dom";

const PaymentList = () => {
    const navigate = useNavigate();

    const onClickHandler = (navigationKey: string):void => {
      switch (navigationKey.toLowerCase()) {
        case 'newProduct':
        navigate('/newProduct/');
        break;
        default:
        navigate('/tenantList/');
      }
    };

    return (
      <div className="p-2 md:p-10">
        <button title="products" className="w-full md:w-1/5 flex items-center p-4 border border-blue rounded-lg bg-white cursor-pointer hover:bg-light-blue hover:text-white hover:stroke-white hover:border hover:border-white" onClick={() => onClickHandler('newProduct')}>
          <h3 className="capitalize text-xl font-semibold">crea prodotto</h3>
        </button>

        <div className="relative overflow-x-auto mt-10">
          <table className="w-full text-sm text-gray-500">
            <thead className="text-sm text-gray-500 uppercase bg-gray-100 border-b border-b-gray-300">
              <tr>
                <th scope="col" className="px-6 py-4 text-left">
                  transaction
                </th>
                <th scope="col" className="px-6 py-4 text-left">
                  date & time
                </th>
                <th scope="col" className="px-6 py-4 text-left">
                  amount
                </th>
                <th scope="col" className="px-6 py-4 text-left">
                  status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b border-b-gray-300">
                <th scope="row" className="px-6 py-4 text-sm whitespace-nowrap text-left">
                  Paymenyt from <span className="capitalize font-semibold text-black">bonnie green</span>
                </th>
                <td className="px-6 py-4 text-sm text-gray-500 text-left">
                  Apr 23, 2021
                </td>
                <td className="px-6 py-4 font-semibold text-sm text-black text-left">
                  $2300
                </td>
                <td className="px-6 py-4 font-semibold">
                  <span className="py-1 px-2 rounded-lg text-lime-800 bg-lime-600 bg-opacity-30">
                    Completed
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b border-b-gray-300">
                <th scope="row" className="px-6 py-4 text-sm whitespace-nowrap text-left">
                  Paymenyt from <span className="capitalize font-semibold text-black">#00910</span>
                </th>
                <td className="px-6 py-4 text-sm text-gray-500 text-left">
                  Apr 23, 2021
                </td>
                <td className="px-6 py-4 font-semibold text-sm text-black text-left">
                  -$670
                </td>
                <td className="px-6 py-4 font-semibold">
                  <span className="py-1 px-2 rounded-lg text-lime-800 bg-lime-600 bg-opacity-30">
                    Completed
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b border-b-gray-300">
                <th scope="row" className="px-6 py-4 text-sm whitespace-nowrap text-left">
                  Paymenyt failed from <span className="capitalize font-semibold text-black">#087651</span>
                </th>
                <td className="px-6 py-4 text-sm text-gray-500 text-left">
                  Apr 18, 2021
                </td>
                <td className="px-6 py-4 font-semibold text-sm text-black text-left">
                  $234
                </td>
                <td className="px-6 py-4 font-semibold">
                  <span className="py-1 px-2 rounded-lg text-red-700 bg-red-500 bg-opacity-30">
                    Cancelled
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b border-b-gray-300">
                <th scope="row" className="px-6 py-4 text-sm whitespace-nowrap text-left">
                  Paymenyt from <span className="capitalize font-semibold text-black">lana byrd</span>
                </th>
                <td className="px-6 py-4 text-sm text-gray-500 text-left">
                  Apr 15, 2021
                </td>
                <td className="px-6 py-4 font-semibold text-sm text-black text-left">
                  $5000
                </td>
                <td className="px-6 py-4 font-semibold">
                  <span className="py-1 px-2 rounded-lg text-violet-800 bg-violet-600 bg-opacity-30">
                    In progess
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b border-b-gray-300">
                <th scope="row" className="px-6 py-4 text-sm whitespace-nowrap text-left">
                  Paymenyt from <span className="capitalize font-semibold text-black">jese leos</span>
                </th>
                <td className="px-6 py-4 text-sm text-gray-500 text-left">
                  Apr 15, 2021
                </td>
                <td className="px-6 py-4 font-semibold text-sm text-black text-left">
                  $2300
                </td>
                <td className="px-6 py-4 capitalize font-semibold">
                  <span className="py-1 px-2 rounded-lg text-lime-800 bg-lime-600 bg-opacity-30">
                    Completed
                  </span>
                </td>
              </tr>
              <tr className="bg-white border-b border-b-gray-300">
                <th scope="row" className="px-6 py-4 text-sm whitespace-nowrap text-left">
                  Paymenyt from <span className="capitalize font-semibold text-black">THEMSBERG LLC</span>
                </th>
                <td className="px-6 py-4 text-sm text-gray-500 text-left">
                  Apr 11, 2021
                </td>
                <td className="px-6 py-4 font-semibold text-sm text-black text-left">
                  $560
                </td>
                <td className="px-6 py-4 font-semibold">
                  <span className="py-1 px-2 rounded-lg text-lime-800 bg-lime-600 bg-opacity-30">
                    Completed
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    );
};
export default PaymentList;
